import { render, staticRenderFns } from "./ComContactSelect.vue?vue&type=template&id=43572acd"
import script from "./ComContactSelect.vue?vue&type=script&lang=js"
export * from "./ComContactSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports